var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRdvIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_313",
    "data-name": "Rectangle 313",
    width: 47,
    height: 46,
    transform: "translate(-0.15 0.354)",
    fill: "#202b53"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_474",
    "data-name": "Groupe 474",
    transform: "translate(0.15 -0.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_475",
    "data-name": "Groupe 475",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_474-2",
    "data-name": "Groupe 474",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_753",
    "data-name": "Trac\\xE9 753",
    d: "M39.677,2.745a3.969,3.969,0,0,0-7.517-.1H26.324a3.969,3.969,0,0,0-7.484,0H13a3.969,3.969,0,0,0-7.517.1A6.625,6.625,0,0,0,0,9.262V41.195a3.974,3.974,0,0,0,3.969,3.97H41.194a3.974,3.974,0,0,0,3.969-3.97V9.262a6.625,6.625,0,0,0-5.487-6.518m-3.775-.1A1.325,1.325,0,0,1,37.225,3.97V6.616a1.323,1.323,0,1,1-2.646,0V3.97A1.325,1.325,0,0,1,35.9,2.646m-13.32,0A1.325,1.325,0,0,1,23.9,3.97V6.616a1.323,1.323,0,1,1-2.646,0V3.97a1.325,1.325,0,0,1,1.323-1.323m-13.32,0A1.325,1.325,0,0,1,10.585,3.97V6.616a1.323,1.323,0,1,1-2.646,0V3.97A1.325,1.325,0,0,1,9.262,2.646M2.646,9.262A3.976,3.976,0,0,1,5.293,5.52v1.1a3.969,3.969,0,1,0,7.939,0V5.293h5.381V6.616a3.969,3.969,0,1,0,7.939,0V5.293h5.381V6.616a3.969,3.969,0,1,0,7.939,0V5.52a3.976,3.976,0,0,1,2.646,3.742V13.32H2.646ZM42.517,41.195a1.325,1.325,0,0,1-1.323,1.323H3.969a1.325,1.325,0,0,1-1.323-1.323V15.966H42.517Z",
    transform: "translate(1.113 1.012)",
    fill: "#202b53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_754",
    "data-name": "Trac\\xE9 754",
    d: "M126.293,254.232a2.649,2.649,0,0,1-2.646-2.646,1.323,1.323,0,1,0-2.646,0,5.293,5.293,0,1,0,6.911-5.04l3.287-3.287a1.325,1.325,0,0,0-.936-2.259h-7.939a1.323,1.323,0,0,0,0,2.646h4.745l-3.034,3.034a1.324,1.324,0,0,0,.936,2.259h1.323a2.646,2.646,0,0,1,0,5.293",
    transform: "translate(-109.214 -218.729)",
    fill: "#202b53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_755",
    "data-name": "Trac\\xE9 755",
    d: "M272.323,254.218a1.323,1.323,0,1,0,0,2.646h10.585a1.323,1.323,0,1,0,0-2.646h-3.969V242.31a1.325,1.325,0,0,0-2.259-.936l-5.293,5.293a1.323,1.323,0,1,0,1.871,1.871l3.034-3.034v8.714Z",
    transform: "translate(-245.983 -218.715)",
    fill: "#202b53"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdvIcon);
export default __webpack_public_path__ + "static/media/rdv-icon.64f91839e13034d4224fcb05f3126f0c.svg";
export { ForwardRef as ReactComponent };